export function selectDictLabel(datas, value) {
  var actions = [];
  Object.keys(datas).map((key) => {
    if (datas[key].dictId ==value) {
      actions.push(datas[key].dictLabel);
      return false;
    }
  })
  return actions.join('');
}



// WEBPACK FOOTER //
// ./src/utils/index.js